import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import PatiHikayeleri from "./pages/PatiHikayeleri";
import Contact from "./pages/Contact";
import SinglePostPage from "./pages/SinglePostPage";
import Hekimlerimizden from "./pages/Hekimlerimizden";
import SearchResultsPage from "./pages/SearchResultsPage";
// Vercel'i tetiklemek için test güncellemesi

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout Route: Tüm sayfalar bu layout'u kullanacak */}
        <Route path="/" element={<Layout />}>
          {/* Layout içindeki Outlet'e yerleşecek olan sayfalar */}
          <Route index element={<Home />} />
          <Route path="hakkimizda" element={<About />} />
          <Route path="pati-hikayeleri" element={<PatiHikayeleri />} />
          <Route path="pati-hikayeleri/:slug" element={<SinglePostPage />} />
          <Route path="hekimlerimizden" element={<Hekimlerimizden />} />
          <Route path="hekimlerimizden/:slug" element={<SinglePostPage />} />
          <Route path="arama" element={<SearchResultsPage />} />
          <Route path="iletisim" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
